import React from 'react'
import './contacts.css'
import {MdOutlineEmail} from 'react-icons/md'
import { useRef } from 'react';
import {BsLinkedin} from 'react-icons/bs'
import {IoLogoWhatsapp} from 'react-icons/io'
import emailjs from 'emailjs-com'

const Contacts = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_zr4l14r', 'template_tp38w87', form.current, '_sSyHN5KvwD3ri0bU')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
        <article className="contact__option">
        <MdOutlineEmail />
          <h4>Email</h4>
          <h5>prateekportfolio@gmail.com</h5>
          <a href="mailto:prateekportfolio@gmail.com" target="_blank">Send mail</a>
        </article>

        <article className="contact__option">
        <BsLinkedin />
          <h4>LinkedIn</h4>
          <h5>Prateek Arora</h5>
          <a href="https://www.linkedin.com/in/prateek-arora-917782191/" target="_blank">Send Request</a>
        </article>

        <article className="contact__option">
        <IoLogoWhatsapp />
          <h4>Whats App</h4>
          <h5>+91 7976882910</h5>
          <a href="https://api.whatsapp.com/send?phone=917976882910" target="_blank">Send Message</a>
        </article>

        </div>

          <form ref={form} onSubmit={sendEmail}>
            <input type="text" name='name' placeholder= 'Your Full Name' required />
            <input type="email" name = 'email' placeholder='Your Email' required/>
            <textarea name="message" rows="8" placeholder='Your Message' required></textarea>
            <button type= 'submit' className='btn btn-primary'>Send Message</button>

          </form>

      </div>
    </section>
  )
}

export default Contacts